// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3vDKy","content":"RecentSearches_content__Tw7dy"};